import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import MissingFieldsModalComponent from '../components/MissingFieldsModal';

type MissingField = {
  field: string;
  stage: number;
  callback: () => void;
};

type MissingFieldsModalProps = RouteComponentProps & {
  onClose: (visible: boolean) => void;
  missingFields: MissingField[];
};

function MissingFieldsModal(props: MissingFieldsModalProps) {
  return <MissingFieldsModalComponent {...props} />;
}

export default withRouter(MissingFieldsModal);
